exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?{\"modules\":true,\"localIdentName\":\"[name]__[local]__[hash:base64:5]\"}!../../styles/colors.css"), undefined);

// module
exports.push([module.id, ".table__wrapper__1D6OP{width:100%}.table__helpText__2HR9z{color:#464646;display:block;margin:10px 0}.table__helpText__2HR9z a{color:#0075c9;text-decoration:none}.table__helpText__2HR9z a:hover{text-decoration:underline}.table__helpWrapper__29qc0{background-color:#edf1f2;padding:15px}.table__helpTextGroup__W8Yr-{text-align:center;width:100%}@media screen and (min-width:778px){.table__helpTextGroup__W8Yr-{text-align:left;float:left;width:50%}}", ""]);

// exports
exports.locals = {
	"blue": "" + require("-!../../../node_modules/css-loader/index.js?{\"modules\":true,\"localIdentName\":\"[name]__[local]__[hash:base64:5]\"}!../../styles/colors.css").locals["blue"] + "",
	"grayDark": "" + require("-!../../../node_modules/css-loader/index.js?{\"modules\":true,\"localIdentName\":\"[name]__[local]__[hash:base64:5]\"}!../../styles/colors.css").locals["grayDark"] + "",
	"wrapper": "table__wrapper__1D6OP",
	"helpText": "table__helpText__2HR9z",
	"helpWrapper": "table__helpWrapper__29qc0",
	"helpTextGroup": "table__helpTextGroup__W8Yr-"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./app/components/table/table.css
// module id = 744
// module chunks = 0